export * from "./dates.js";
export * from "./image.js";
export * from "./localStorage.ts";
export * from "./string.js";
export * from "./validation.ts";

export const extractYouTubeVideoId = (url) => {
  const regex =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?vi?=|&vi?=))([^#&?]*).*/;
  const match = url.match(regex);
  return match ? match[1] : null;
};


export function isBasedInNYC(city, state) {
    if (!city || !state) return false;

    const NYC_CITIES = [
        "new york",
        "new york city",
        "nyc",
        "manhattan",
        "brooklyn",
        "queens",
        "bronx",
        "the bronx",
        "staten island"
    ];

    const normalizedCity = city.toLowerCase().trim();
    const normalizedState = state.toLowerCase().trim();

    return normalizedState === "new york" && NYC_CITIES.includes(normalizedCity);
}
